export default "<div class=\"jumbotron container-image\">\r\n    <h1 class=\"titulo-home\" >Bienvenidos a Burguer Queen</h1>\r\n\r\n</div>";